module.exports = __webpack_public_path__ + "static/media/LogoCidadeJardimWhite.a0b907e3.svg";